var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.items,"headers":_vm.headers,"footer-props":{
    'items-per-page-options': [25,50,100,-1]
  }},scopedSlots:_vm._u([{key:"item",fn:function(ref){
  var item = ref.item;
return [_c('tr',_vm._l((item),function(granted,i){return _c('td',{key:("permission-" + i)},[(i === 0)?_c('span',[_vm._v(_vm._s(granted))]):_c('div',[_c('v-checkbox',{staticClass:"justify-center ma-0",attrs:{"input-value":granted,"color":"primary","hide-details":"","disabled":""}})],1)])}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }